import Prospects from '@/components/prospects/Prospects'
import ProspectDetail from '@/components/prospects/ProspectDetail'
import ProspectCreate from '@/components/prospects/ProspectCreate'
import ProspectUpdate from '@/components/prospects/ProspectUpdate'

const prospectsRoutes = [
  { path: '/prospects', name: 'prospects', component: Prospects },
  { path: '/prospect/create', name: 'prospect_create', component: ProspectCreate },
  { path: '/prospect/update/:id', name: 'prospect_update', component: ProspectUpdate },
  { path: '/prospect/:id', name: 'prospect', component: ProspectDetail }
]

export default prospectsRoutes



// WEBPACK FOOTER //
// ./src/router/prospects_routes.js